import Vue from 'vue';
import VueRouter from 'vue-router';
import axios from 'axios';

import Registration from '../pages/Registration.vue';
import ResetPassword from '../pages/ResetPassword.vue';
import PersonalData from '../pages/PersonalData.vue';
import PersonalDataExpired from '../pages/PersonalDataExpired.vue';
import Orgs from '../pages/Orgs.vue';
import Tour from '../pages/Tour.vue';
import School from '../pages/School.vue';
// import Photo from '../pages/Photo.vue';
import Photo23 from '../pages/archive/Photo23.vue';
import Photo24 from '../pages/archive/Photo24.vue';
import Photo25 from '../pages/archive/Photo25.vue';
import Program from '../pages/Program.vue';
import Program23 from '../pages/archive/Program23.vue';
import Program24 from '../pages/archive/Program24.vue';
import Program25 from '../pages/archive/Program25.vue';
import Theses from '../pages/Theses.vue';
import Thesis23 from '../pages/archive/Thesis23.vue';
import Thesis24 from '../pages/archive/Thesis24.vue';
import Thesis25 from '../pages/archive/Theses25.vue';
import UsersList from '../pages/UsersList.vue';
import Dashboard from '../pages/Dashboard.vue';
import DariaList from '../pages/DariaList.vue';
import RegisterFinish from '../pages/RegisterFinish.vue';
import NewLogin from '../pages/NewLogin.vue';
import HomePage from '../pages/HomePage.vue';
import Page404 from '../pages/404.vue';
import VerifyUser from '../pages/VerifyUser.vue'
import Policy from '../pages/Policy.vue'
import ModerUsersList from '../pages/ModerUsersList.vue';

import NotFoundPage from '../components/Common/NotFoundPage.vue';

import { AUTH_URL } from '../../vars';

Vue.use(VueRouter);
const routes = [
  {
    path: '/404',
    name: '404',
    component: Page404
  },
  {
    path: '*',
    redirect: '/404'
  },
  {
    path: '/login',
    name: 'Login',
    component: NewLogin,
    meta: { title: 'Вход' },
  },
  {
    path: '/registration',
    name: 'Registration',
    component: Registration,
    meta: {title: 'Регистрация' },
  },
  {
    path: '/',
    name: 'Home',
    component: HomePage,
    meta: { title: 'Курчатов ФСНЭ 2026' },
  },
  {
    path: '/privacy',
    name: 'Policy',
    component: Policy,
    meta: { requiresAuth: true, title: 'Политика в отношении обработки персональных данных' },
  },
  // {
  //   path: '/',
  //   name: 'Home',
  //   component: NewLogin,
  //   meta: { title: 'Вход' },
  // },
  {
    path: '/users-list',
    name: 'UsersList',
    component: UsersList,
    meta: { requiresAuth: false,  title: 'Участники' },
  },
  {
    path: '/moder-list',
    name: 'ModerUsersList',
    component: ModerUsersList,
    meta: { requiresAuth: false,  title: 'Участники: редактирование' },
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: Dashboard,
    meta: { requiresAuth: false,  title: 'Dashboard' },
  },
  {
    path: '/daria-users',
    name: 'DariaList',
    component: DariaList,
    meta: { requiresAuth: false,  title: 'Проект DARIA: Участники' },
  },
  {
    path: '/register-finish/:email',
    name: 'RegisterFinish',
    component: RegisterFinish,
    props: true,
  },
  {
    path: '/reset-password',
    name: 'ResetPassword',
    component: ResetPassword,
    meta: { title: 'Восстановление пароля' },
  },
  {
    path: '/not-found',
    name: 'NotFoundPage',
    component: NotFoundPage,
    meta: { title: 'Страница не найдена' },
  },
  {
    path: '/personal-data',
    name: 'PersonalData',
    component: PersonalData,
    meta: { requiresAuth: true, title: 'Личные данные' },
  },
  {
    path: '/expired_reg_6l3jd2fp',
    name: 'PersonalDataExpired',
    component: PersonalDataExpired,
    meta: { requiresAuth: true, title: 'Личный кабинет' },
  },

  {
    path: '/orgs',
    name: 'Orgs',
    component: Orgs,
    meta: { requiresAuth: true, title: 'Контакты' },
  },
  {
    path: '/tour',
    name: 'Tour',
    component: Tour,
    meta: { requiresAuth: true, title: 'Запись на экскурсию' },
  },
  {
    path: '/school',
    name: 'School',
    component: School,
    meta: { requiresAuth: true, title: 'Школа молодых ученых' },
  },

  // {
  //   path: '/photo',
  //   name: 'Photo',
  //   component: Photo,
  //   meta: { requiresAuth: true, title: 'Фотографии' },
  // },
  {
    path: '/program',
    name: 'Program',
    component: Program,
    meta: { requiresAuth: true, title: 'Программа' },
  },
  {
    path: '/theses',
    name: 'Theses',
    component: Theses,
    meta: { requiresAuth: true, title: 'Тезисы' },
  },
  {
    path: '/thesis-23',
    name: 'Thesis23',
    component: Thesis23,
    meta: { requiresAuth: true, title: 'Сборник тезисов 2023' },
  },
  {
    path: '/verify-user',
    name: 'VerifyUser',
    component: VerifyUser
  },

// HISTORY
  {
    path: '/photo-23',
    name: 'Photo23',
    component: Photo23,
    meta: { requiresAuth: true, title: 'Фотографии 2023' },
  },
  {
    path: '/program-23',
    name: 'Program-23',
    component: Program23,
    meta: { requiresAuth: true, title: 'Программа 2023' },
  },
  {
    path: '/users-list-23',
    name: 'UsersList-23',
    component: UsersList,
    meta: { requiresAuth: false,  title: 'Участники 2023' },
  },
  {
    path: '/photo-24',
    name: 'Photo24',
    component: Photo24,
    meta: { requiresAuth: true, title: 'Фотографии 2024' },
  },
  {
    path: '/program-24',
    name: 'Program-24',
    component: Program24,
    meta: { requiresAuth: true, title: 'Программа 2024' },
  },
  {
    path: '/users-list-24',
    name: 'UsersList-24',
    component: UsersList,
    meta: { requiresAuth: false,  title: 'Участники 2024' },
  },
  {
    path: '/thesis-24',
    name: 'Thesis24',
    component: Thesis24,
    meta: { requiresAuth: true, title: 'Сборник тезисов 2024' },
  },
  {
    path: '/photo-25',
    name: 'Photo25',
    component: Photo25,
    meta: { requiresAuth: true, title: 'Фотографии 2025' },
  },
  {
    path: '/program-25',
    name: 'Program-25',
    component: Program25,
    meta: { requiresAuth: true, title: 'Программа 2025' },
  },
  {
    path: '/users-list-25',
    name: 'UsersList-25',
    component: UsersList,
    meta: { requiresAuth: false,  title: 'Участники 2025' },
  },
  {
    path: '/thesis-25',
    name: 'Thesis25',
    component: Thesis25,
    meta: { requiresAuth: true, title: 'Сборник тезисов 2025' },
  },
];

function wait(duration) {
  return new Promise((resolve) => setTimeout(resolve, duration));
}

async function tryScrollToAnchor(hash, timeout = 1000, delay = 100) {
  while (timeout > 0) {
    const el = document.querySelector(hash);
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
      break;
    }
    await wait(delay);
    timeout = timeout - delay;
  }
}

const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      tryScrollToAnchor(to.hash, 1000, 100);
    } else if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
});
const DEFAULT_TITLE = 'KCSNR User Portal';
router.afterEach((to, from) => {
  // Use next tick to handle router history correctly
  // see: https://github.com/vuejs/vue-router/issues/914#issuecomment-384477609
  // console.log(from);
  Vue.nextTick(() => {
    document.title = to.meta.title || DEFAULT_TITLE;
    const link = document.querySelector("link[rel*='icon']") || document.createElement('link');
    link.type = 'image/x-icon';
    link.rel = 'shortcut icon';
    link.href = 'https://api.kcsni-service.ru/media/logo_black.png';
    document.getElementsByTagName('head')[0].appendChild(link);
  });
});
router.beforeEach(async (to, from, next) => {
  try {
    // if (to.matched.some((record) => record.meta.requiresAuth)) {
    //   const auth = await axios.get(`${AUTH_URL}profile/`, {
    //     headers: {
    //       Authorization: `Token ${localStorage.token}`,
    //     },
    //   });

    //   if (!auth) {
    //     next({
    //       path: '/login',
    //     });
    //   } else {
    //     next();
    //   }
    // } else {
      next();
    // }
  } catch (ex) {

    next();
    // if (router.history.current.fullPath != '/login'){
    //   next({
    //     path: '/login',
    //   });
    // }

  }
});

export default router;
